import React from 'react'
import './Story.css'

function Story() {
  return (
    <div className='story-section'>
        <div className='story-information'>
            <h2 className='header2'>
                Our Malaika Doulas Story
            </h2>
            <p className='p-small'>My name is Cecilia Wanjiru, and I am a passionate postpartum doula with over 10 years of experience supporting new parents physically, mentally, and emotionally. As a mother of three, I understand the joys and challenges of parenting firsthand.</p>
            <p className='p-small'>For over 25 years, I have dedicated my career to caring for children, working as a nanny for newborns through teenagers. I also bring valuable expertise from my years as a Certified Nursing Assistant (CNA) and Home Health Aide (HHA).</p>
            <p className='p-small'>What I love most about my work is the opportunity to make a meaningful difference in people’s lives. It brings me immense joy to help new parents navigate the early days of parenthood with confidence and support. Hearing someone say, “We couldn’t have done this without your help,” reassures me that I am fulfilling my mission to empower families and create lasting positive impacts.</p>
            <p className='p-small'>I look forward to continuing to share my knowledge, compassion, and dedication with families during one of life’s most transformative experiences.</p>
        </div>

        <div className='story-profile'>
            <img src={require('../assets/storyprofile.webp')} alt='Wanjiru' className='story-image-profile'/>
            <h3>Cecilia Wanjiru</h3>
            <p className='p-small italic'>Certified Postpartum Doula</p>
        </div>
    </div>
  )
}

export default Story